import { Injectable, inject } from '@angular/core';

import { QueryGetDependencySubTreeArgs } from 'projects/semeris/src/generated/graphql-models';
import { Observable } from 'rxjs';

import { GraphQLService } from '../../shared/services/graphql.service';
import { GET_DEPENDENCY_SUB_TREE } from '../constants/dependency.queries';
import { DependencyTreeItem } from '../models/dependency-tree-item.model';

@Injectable({ providedIn: 'root' })
export class DependencyService {
  private readonly graphQLService = inject(GraphQLService);

  public getDependencyTreeItems(id: string, type: string): Observable<DependencyTreeItem[]> {
    return this.graphQLService.getManyQuery<DependencyTreeItem, QueryGetDependencySubTreeArgs>(
      GET_DEPENDENCY_SUB_TREE,
      { id, type }
    );
  }
}
